import styled from 'styled-components'

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
  tr {
    padding: 10px 0px;
    border: 1px solid #f0f0f0;
  }
`

export const Thead = styled.thead`
  background: #f7f7f7;
  background-size: auto 100%;
  tr {
    font-size: 14px;
    color: #666;
    border: 1px solid #f0f0f0;
    :first-child {
      border: 1px solid #f0f0f0;
      border-bottom: 4px solid #f0f0f0;
    }
  }
  th {
    background-color: #f7f7f7;
    padding: 0px 0px 0px 10px;
    height: 56px;
    text-align: center;
    word-break: break-all;
    color: #333;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    position: sticky;
    top: -1px;
    &:hover {
      color: #f0b90b;
    }
    &:first-child {
      border-right: 1px solid #f0f0f0;
      padding: 0;
      &:hover {
        color: #333;
      }
    }
    :last-child {
      padding-right: 10px;
    }
  }
  .showSortMark {
    i {
      display: none;
    }
  }
  .sortHd {
    i {
      display: inline-block;
    }
  }
`

export const Tbody = styled.tbody`
  tr {
    &:hover {
      background-color: #fffbf3;
    }
  }
  td {
    padding: 6px 0px 6px 10px;
    position: relative;
    text-align: center;
    word-break: break-all;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    min-height: 60px;
    :first-child {
      border-right: 1px solid #f0f0f0;
      color: #999;
      padding: 0;
      width: 34px;
      font-size: 12px;
    }
    :last-child {
      padding-right: 10px;
    }
  }
`

export default Table
